import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./style/App.scss";
import "./style/glyphicon.scss";
import Home from "./Home.js";
import Callback from "./Callback";
import Header from "./Header";
import Footer from "./Footer";
import OnAir from "./OnAir";
import Volunteer from "./Volunteer";
import AddVolunteer from "./AddVolunteer";
import Albums from "./Albums";
import Program from "./Program";
import AddProgram from "./AddProgram";
import Psa from "./Psa";
import AddPsa from "./AddPsa";
import Survey from "./Survey";
import AddSurvey from "./AddSurvey";
import AddAlbum from "./AddAlbum";
import Report from "./Report";
import Playlists from "./Playlists";
import AddPlaylist from "./AddPlaylist";
import PrivateRoute from "./PrivateRoute";
import KUGSPlayer from "./components/KUGSPlayer";
import { login, logout } from "./services/AuthService";

function App() {
  return (
    <div>
      <Router>
        <Header />
        <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/programs" exact component={Program} />
        <Route path="/report" exact component={Report} />
        <PrivateRoute path="/programs/add" exact component={AddProgram} />
        <PrivateRoute
          path="/programs/:id(\d+)/"
          exact
          component={AddProgram}
        />
        <Route path="/survey" exact component={Survey} />
        <PrivateRoute path="/survey/add" exact component={AddSurvey} />
        <PrivateRoute
          path="/survey/:id(\d+)/"
          exact
          component={AddSurvey}
        />
        <Route path="/psa" exact component={Psa} />
        <PrivateRoute path="/psa/add" exact component={AddPsa} />
        <PrivateRoute
          path="/psa/:id(\d+)/"
          exact
          component={AddPsa}
        />
        <PrivateRoute path="/volunteers/" exact component={Volunteer} />
        <PrivateRoute
          path="/volunteers/:id(\d+)/"
          exact
          component={AddVolunteer}
        />
        <PrivateRoute path="/volunteers/add/" exact component={AddVolunteer} />
        <PrivateRoute path="/albums/" exact component={Albums} />
        <PrivateRoute path="/albums/:id(\d+)/" exact component={AddAlbum} />
        <PrivateRoute path="/albums/add/" exact component={AddAlbum} />
        <PrivateRoute path="/playlists/" exact component={Playlists} />
        <PrivateRoute
          path="/playlists/:id(\d+)/"
          exact
          component={AddPlaylist}
        />
        <PrivateRoute path="/playlists/add/" exact component={AddPlaylist} />
        <PrivateRoute path="/on-air/" exact component={OnAir} />
        <Route path="/callback/" exact component={Callback} />
        <Route path="/login/" exact component={login} />
        <Route path="/logout/" exact component={logout} />
        <Route path="/player/" exact component={KUGSPlayer} />
        </Switch>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
